import API from "./API";

const SegmentClassSPService = {
  async getParticularSegmentClassSP(
    segmentLobId: number,
    customerTypeId: number
  ) {
    const response = await API().get(
      "SegmentClassification/GetSCBySegmentLobCustomerType/" +
        segmentLobId +
        "/" +
        customerTypeId,
      {
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      }
    );
    return response.data[0];
  },
};

export default SegmentClassSPService;
